const defaultState = {
    error: null,
    fetching: false,
    fetched: false,
    data: null
};

const searchDataRetention = (state = defaultState, action) => {
    switch (action.type) {
        case 'DATA_RETENTION_FETCH_PENDING': {
            return {
                ...state, error: null, fetching: true
            };
        }
        case 'DATA_RETENTION_FETCH_FULFILLED': {
            return {
                ...state,
                error: null,
                fetching: false,
                fetched: true,
                data: action.payload.data
            };
        }
        case 'DATA_RETENTION_FETCH_REJECTED': {
            return {
                ...state,
                error: action.payload,
                fetching: false,
                fetched: false,
                data: null,
            };
        }
        default:
            break;
    }

    return state;
};

export default searchDataRetention;


// WEBPACK FOOTER //
// ./src/reducers/searchDataRetention.js